import * as constants from './constants'
import omit from 'lodash.omit'
import { CLEAR_SELECTED_RATE } from 'booking/constants'

const locationsInitialState = {
    results: [],
    resultsCount: 0,
    googleResults: [],
    googleResultsCount: 0,
    searchLocation: {
        lat: 51.507351,
        lng: -0.127758,
    },
    distance: 100,
    selectedLocation: null,
}

export function locationReducer(state = locationsInitialState, action) {
    switch (action.type) {
        case constants.SEARCH_LOCATIONS_RECEIVED: {
            const { results, resultsCount } = action

            return {
                ...state,
                results,
                resultsCount,
            }
        }

        case constants.GOOGLE_SEARCH_LOCATIONS_RECEIVED: {
            const { result } = action

            return {
                ...state,
                googleResults: result,
                googleResultsCount: result.length,
            }
        }

        case constants.CLEAR_SEARCH_LOCATIONS:
            return {
                ...state,
                results: locationsInitialState.results,
                resultsCount: 0,
            }
        case constants.CLEAR_GOOGLE_SEARCH_LOCATIONS:
            return {
                ...state,
                googleResults: locationsInitialState.googleResults,
                googleResultsCount: 0,
            }

        case constants.SELECT_SEARCH_LOCATION: {
            const { location } = action
            return {
                ...state,
                location,
            }
        }

        case constants.REMOVE_SEARCH_LOCATION:
            return omit({ ...state }, 'location')

        default:
            return state
    }
}

const eventsInitialState = {
    results: [],
    searchEventInput: '',
    selectedEvent: null,
}

export function eventsReducer(state = eventsInitialState, action) {
    switch (action.type) {
        case constants.SEARCH_EVENTS_RECEIVED:
            return {
                ...state,
                results: action.results,
            }

        case constants.CLEAR_SEARCH_EVENTS:
            return {
                ...state,
                results: eventsInitialState.results,
            }

        case constants.SET_EVENT:
            return {
                ...state,
                selectedEvent: action.event,
            }
        case constants.ADD_EVENT_DETAILS:
            return {
                ...state,
                selectedEvent: {
                    ...state.selectedEvent,
                    ...action.rateDetails,
                },
            }

        case constants.REMOVE_EVENT:
        case CLEAR_SELECTED_RATE:
            return {
                ...state,
                selectedEvent: eventsInitialState.selectedEvent,
            }

        case constants.SET_SEARCH_EVENT_INPUT_VALUE: {
            return {
                ...state,
                searchEventInput: action.event,
            }
        }

        default:
            return state
    }
}
